import { VermittlerFom } from '@ps20/bff-models';
import { StatePreV15, StateV15 } from './15_migrate_vermittlernummer.interface';

export const migrateVermittlernummer = (
  previousState: StatePreV15,
  newVersion: number,
): StateV15 => {
  const isFremdVermittler = previousState.vermittler?.fremd;
  const isEigenVermittler = isFremdVermittler === false;
  const newState = {
    ...previousState,
    version: newVersion,
    vermittler: {
      ...previousState.vermittler,
      selectedVermittlernummer: {
        ...previousState.vermittler?.selectedVermittlernummer,
        fremd: {
          zweigniederlassung: isFremdVermittler
            ? previousState.vermittler.selectedVermittlernummer.zweigniederlassung
            : '',
          geschaeftsstelle: isFremdVermittler
            ? previousState.vermittler.selectedVermittlernummer.geschaeftsstelle
            : '',
          vertreternummer: isFremdVermittler
            ? previousState.vermittler.selectedVermittlernummer.vertreternummer
            : '',
          vermittlerFom: isFremdVermittler
            ? previousState.vermittler.selectedVermittlernummer.vermittlerFom
            : VermittlerFom.NONE,
        },
        eigen: {
          zweigniederlassung: isEigenVermittler
            ? previousState.vermittler.selectedVermittlernummer.zweigniederlassung
            : '',
          geschaeftsstelle: isEigenVermittler
            ? previousState.vermittler.selectedVermittlernummer.geschaeftsstelle
            : '',
          vertreternummer: isEigenVermittler
            ? previousState.vermittler.selectedVermittlernummer.vertreternummer
            : '',
          vermittlerFom: isEigenVermittler
            ? previousState.vermittler.selectedVermittlernummer.vermittlerFom
            : VermittlerFom.NONE,
        },
      },
    },
  };
  if (newState.vermittler) {
    delete newState.vermittler.selectedVermittlernummer.vermittlerFom;
    delete newState.vermittler.selectedVermittlernummer.vertreternummer;
    delete newState.vermittler.selectedVermittlernummer.geschaeftsstelle;
    delete newState.vermittler.selectedVermittlernummer.zweigniederlassung;
  }
  return newState;
};
